<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_user_badges" autocomplete="off">
                <v-layout row wrap>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="user_badges.user_badge_color" type="color"
                            :label="$store.getters.lang.data.user_badge_color" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="user_badges.user_badge_name" type="text"
                            :label="$store.getters.lang.data.user_badge_name" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="user_badges.user_badge_svg" type="text"
                            :label="$store.getters.lang.data.user_badge_svg" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->
                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large>{{$store.getters.lang.data.add_btn}}
                            user badges</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            {{$store.getters.lang.data.user_badges}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="user_badge_id">
                                <template v-slot:[`item.user_badge_id`]="{ item }">
                                    <div>
                                        <v-btn v-if="item.user_badge_id != 1" icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_user_badges(item)"
                                            rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/user_badges-list/'+item.user_badge_id" icon color="secondary"
                                            class="mx-1" rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <template v-slot:[`item.user_badge_color`]="{ item }">
                                    <div>
                                        <v-icon :color="item.user_badge_color">fas fa-circle</v-icon>
                                        {{item.user_badge_color}}
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                        {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_user_badges(selected_user_badges.user_badge_id)">
                        {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/user_badges'
    export default {
        data() {
            return {
                user_badges: {},
                search: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_user_badges: {},
                delete_dialog: false,
                headers: [
                    {
                        text: this.$store.getters.lang.data.user_badge_color,
                        align: 'start',
                        sortable: true,
                        value: 'user_badge_color',
                    },


                    {
                        text: this.$store.getters.lang.data.user_badge_name,
                        align: 'start',
                        sortable: true,
                        value: 'user_badge_name',
                    },
                    // {
                    //     text: this.$store.getters.lang.data.user_badge_svg,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'user_badge_svg',
                    // },
                    {
                        text: '#',
                        align: 'start',
                        sortable: true,
                        value: 'user_badge_id',
                    },

                ],
            }
        },
        computed: {
            rows() {
                return this.$store.getters.user_badges
            },


        },
        mounted() {
            this.read_user_badges();
        },
        methods: {
            add_user_badges() {
                controller.add_user_badges(this.user_badges).then(r => {
                    if (r.data) {
                        this.user_badges = {}
                        this.$store.state.user_badges.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'user_badges Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add user_badges',
                            color: 'error'
                        }
                    }
                })
            },
            delete_user_badges(user_badge_id) {
                controller.delete_user_badges(user_badge_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.user_badges = this.$store.state.user_badges.filter(f => {
                            return f.user_badge_id != user_badge_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'user_badges Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_user_badges() {
                this.loading = true
                controller.get_user_badges().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_user_badges(i) {
                this.selected_user_badges = i
                this.delete_dialog = true
            },
        },
    }
</script>